import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PrincipalService } from '@ms/core/auth/principal.service';
import { TranslateService } from '@ngx-translate/core';
import { IUserProfile } from 'app/layout/model/profile.model';
import { memoize } from 'lodash-es';

@Pipe({
    name: 'dateFormat',
    pure: false,
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
    _profile: IUserProfile;
    lastValue: string | Date;
    lastArgs: any;
    _value: string;
    converter = memoize(this.convert, (...args) => this.convert(args[0], args[1]));
    constructor(
        @Inject(LOCALE_ID) lang,
        private _principalService: PrincipalService,
        private _translateService: TranslateService
    ) {
        super(lang);
        this._profile = this._principalService.profile;
        this._translateService.onLangChange.pipe(takeUntilDestroyed()).subscribe(event => {
            if (this._profile.id != event.lang) {
                this._profile = this._principalService.profile;
                this.lastValue = undefined;
                this.lastArgs = undefined;
            }
        });
    }

    override transform(value: string | Date, args?: any): any {
        return this.converter(value, args);
    }

    private convert(value: string | Date, args: any): string {
        if (this._profile) {
            return (this._value = super.transform(
                value,
                args ? args : this._profile.format.date.formatDate,
                null,
                this._profile.locale
            ));
        } else {
            return (this._value = super.transform(value));
        }
    }
}
